import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxLengthHTML(param: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    if (!value) return null;
    const regex = /(<([^>]+)>)/gi;
    const htmlText = value.replace(regex, '');
    return htmlText.length > param ? { maxlength: { requiredLength: param } } : null;
  };
}
